import { useState } from 'react';
import { useEventos } from '@/api/queries/empresa';
import { Skeleton } from '@/components/ui/skeleton';
import { Plus } from 'lucide-react';
import { EventoForm } from '@/components/EventoForm';

const tipoIcon: Record<string, string> = {
  mensagem_enviada: '↗',
  mensagem_recebida: '↘',
  ligacao_feita: '✆',
  ligacao_recebida: '✆',
  email_enviado: '✉',
  email_recebido: '✉',
  call_agendada: '◷',
  call_realizada: '●',
  call_no_show: '✗',
  audit_criado: '◆',
  audit_revisado: '◇',
  nota_adicionada: '✎',
  status_mudou: '⟳',
  lead_ops_bridge: '⇄',
  proposta_enviada: '⊟',
  proposta_aceita: '✓',
  proposta_recusada: '✗',
};

export function TabTimeline({ empresaId }: { empresaId: string }) {
  const { data, isLoading } = useEventos(empresaId, 50);
  const [formOpen, setFormOpen] = useState(false);

  if (isLoading) return <Skeleton className="h-64 mt-4" />;

  return (
    <div className="mt-4 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-muted-foreground">
          {data?.items.length ?? 0} evento{(data?.items.length ?? 0) === 1 ? '' : 's'}
        </h3>
        <button
          type="button"
          onClick={() => setFormOpen(true)}
          className="inline-flex items-center gap-1.5 rounded-md bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          <Plus className="h-4 w-4" />
          Registrar evento
        </button>
      </div>

      {!data || data.items.length === 0 ? (
        <p className="text-muted-foreground">Sem eventos.</p>
      ) : (
        <div className="space-y-3 border-l pl-4">
          {data.items.map((ev) => (
            <div key={ev.id} className="relative">
              <span className="absolute -left-[24px] top-0 inline-flex h-5 w-5 items-center justify-center rounded-full bg-muted text-xs">
                {tipoIcon[ev.tipo] ?? '·'}
              </span>
              <div className="text-sm">
                <span className="font-medium">{ev.tipo.replace(/_/g, ' ')}</span>
                <span className="text-muted-foreground">
                  {' '}
                  · {ev.canal} · {new Date(ev.data_evento).toLocaleString('pt-BR')}
                </span>
              </div>
              {ev.payload && Object.keys(ev.payload).length > 0 && (
                <pre className="text-xs text-muted-foreground mt-1 whitespace-pre-wrap font-sans">
                  {typeof ev.payload.resumo === 'string'
                    ? ev.payload.resumo
                    : JSON.stringify(ev.payload, null, 2)}
                </pre>
              )}
            </div>
          ))}
        </div>
      )}

      <EventoForm empresaId={empresaId} open={formOpen} onOpenChange={setFormOpen} />
    </div>
  );
}
